import { ReactComponent as IconPrevious } from '@/assets/svgs/previous-arrow.svg'
import { assetUrl } from '@/utils/asset-url'
import Button from '@/components/Button'
import Portal from '@/components/Portal'
import { ToastContext } from '@/context/toast/index'
import useEclips from '@/hooks/use-eclips/index'
import useModal from '@/hooks/use-modal/index'
import usePage from '@/hooks/use-page'
import { NavLink, useNavigate, useParams } from '@/lib/router-dom/index'
import moment from 'moment'
import { useContext, useEffect } from 'react'
import ReactDatePicker from 'react-datepicker'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next'
import ConfirmDeclineModal from './components/confirm-decline-modal.jsx'
import { DataElementList } from './data-element-list.jsx'
import Breadcrumbs from '@/componentsDS/Breadcrumbs/index.jsx'


function PageTitle({pageTitle}) {
	return (
		<div className="title-header">
			<div className="title-header__left">
				<div className="title-header__title">{pageTitle}</div>
			</div>

			<div className="title-header__right"></div>
		</div>
	)
}

export default function RequestPackagePreview() {
	const { addToastMessage } = useContext(ToastContext)
	const { goTo } = useNavigate();
	// const params = useParams()
	const { eclipId } = useParams()
	const { t } = useTranslation()
	const { loading, get, currentItem: data, respondRequest, setCurrentItem: setData } = useEclips()

	const pageTitle = t('Create Requested Package')
	const { visible, show, hide } = useModal()

	const handleCancel = () => {
		goTo('/eclip')
	}

	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: `/`,
			},
			{
				label: 'Package Sharing',
				link: `/eclip`
			},
			{
				label: `Create Requested Package`,
				link: ``
			},
		],
	})

	const onRejectClick = () => {
		show();
	}
	const onAcceptClick = async () => {
		await respondRequest(eclipId, 'accept', {
			expectedDateOfCompletion: data.expectedDateOfCompletion,
		});
		addToastMessage('You have accepted the package request successfully', 'success',)
		goTo(`/eclip/send/${eclipId}`)
	}

	const onRejectConfirm = async (message) => {
		await respondRequest(eclipId, 'reject', {
			message
		})
		addToastMessage('You have declined the package request successfully', 'success',)
		goTo(`/eclip`)
	}

	useEffect(() => {
		get(eclipId)
	}, [eclipId])

	return (
		<div className="eclip-create__content">
			<ConfirmDeclineModal
				isVisible={visible}
				cancel={hide}
				confirm={onRejectConfirm}
						title={"Decline Package"}
				packageName={data?.name}
			/>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />

			<PageTitle pageTitle={pageTitle}/>

			<form className="eclip-create__form">
				<div className='eclip-create__form--flex'>
					<div className='eclip-create__form--half-width'>
						<div className="eclip-create__form-row">
							<div className="eclip-create__input-label">{t('eclipName')}</div>
							<input
								className="eclip-create__input-field"
								value={data?.name}
								disabled
							/>
						</div>
						<div className="eclip-create__form-row">
							<div className="eclip-create__input-label">{t('eclipReference')}</div>
							<input
								className="eclip-create__input-field"
								value={data?.receivedReferenceNumber}
								disabled
							/>
							<div className="eclip-create__input-description">
								{t('eclipReferenceDescription')}
							</div>
						</div>
						<div className="eclip-create__form-row">
							<div className="eclip-create__input-label">{t('eclipTemplate')}</div>
							<input
								className="eclip-create__input-field"
								value={data?.template}
								disabled
							/>
						</div>
					</div>
					<div className='eclip-create__form--message'>
						<div className='eclip-create__form--wrapper'>
							<div className='eclip-create__form--title'>
								{t('requestor')}
							</div>

							<div className='eclip-create__form--value'>
								{data?.receiveOwner}
							</div>
						</div>
						<div className='eclip-create__form--wrapper'>
							<div className='eclip-create__form--title'>
								{t('message')}
							</div>

							<div className='eclip-create__form--value'>
								{data?.receivedMessage || 'No Message to Show'}
							</div>
						</div>
					</div>
				</div>

				<div className="eclip-create__form-row">
					<div className="eclip-create__input-label eclip-create__input-label--bold">{t('eclipDataElements')} ({data?.dataElements?.length < 9 ? '0' + data?.dataElements?.length : data?.dataElements?.length || '00'})</div>
					<div className='eclip-create__data-element-wrapper'>
						<DataElementList data={data} />
					</div>
				</div>

				<div className="eclip-create__form-row__low-width">
					<div className="eclip-create__input-label">
						{t('eclipExpectedDate')}
					</div>
					<div className="date_picker__container">
						<ReactDatePicker
							dateFormat="d MMM yyyy"
							value={data?.expectedDateOfCompletion}
							onChange={(date) =>{
								setData({
								...data,
								expectedDateOfCompletion: date ? moment(date).format('YYYY-MM-DD') : null
								})
							}}
							// showTimeSelect={false}
							// todayButton="Today"
							// dropdownMode="select"
							// isClearable
							// shouldCloseOnSelect
							// showMonthDropdown
							// showYearDropdown
							placeholderText={t('eclipExpectedDatePlaceholder')}
						/>
					</div>
				</div>

				{loading &&
					ReactDOM.createPortal(
						<div className="modal white">
							<div className="loading">
								<img src={assetUrl("/loading.gif")} />
							</div>
						</div>,
					document.body,
				)}
				<div className="DS__layout__footer">
					<div className="layout-default__sticky-actions">
						<div className="layout-default__sticky-actions__left">
							<Button
								text={t('Cancel')}
								sizing="Medium"
								full
								type="button"
								noborder
								maxWidth="154"
								submit={handleCancel}
							/>
						</div>
						<div
							className="layout-default__sticky-actions__right"
							style={{ display: 'flex' }}
						>
						{data?.requestStatus === 'PENDING' &&
							<div className="overview__button_wrap">
								<Button
									text={t('Decline')}
									sizing="Medium"
									full
									ghost
									type="button"
									submit={onRejectClick}
								/>
								<Button
									text={t('Accept & Create')}
									sizing="Medium"
									full
									type="button"
									submit={onAcceptClick}
								/>
							</div>
						}
						</div>
					</div>
				</div>
			</form>
		</div>
	)
}
